import { AutoCompleteProps } from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n";
import React from "react";
import { IAgentGroup } from "../../models/agentGroups/agentGroup";
import { AgentGroupPicker } from "./agentGroupPicker/agentGroupPicker";
import { CompoundDropdown } from "./compoundDropdown/compoundDropdown";

interface Props extends Pick<AutoCompleteProps<IAgentGroup>, "initialIsOpen" | "className"> {
  values: IAgentGroup[];
  onAdded: (group: IAgentGroup) => void;
  onDeleted: (group: IAgentGroup) => void;
  onClose?: () => void;
}
export const AddDeleteAgentGroupPicker = ({
  values,
  onAdded,
  onDeleted,
  onClose,
  className,
  ...rest
}: Props) => {
  return (
    <CompoundDropdown<Option>
      mapOptionToString={mapOptionToString}
      placeholder={intl.formatMessage("agentGroupAddDeletePicker.placeholder")}
      options={[Option.Add, Option.Delete]}
      onClose={onClose}
      className={className}
    >
      {(helpers) => (
        <AgentGroupPicker
          {...rest}
          className={className}
          values={values}
          onChange={(group) =>
            helpers.selectedOption === Option.Delete ? onDeleted(group) : onAdded(group)
          }
          placeholder={mapOptionToString(helpers.selectedOption)}
          onStateChange={(_, state) => !state.isOpen && helpers.reset()}
        />
      )}
    </CompoundDropdown>
  );
};

const mapOptionToString = (option: Option | null) => {
  switch (option) {
    case Option.Add:
      return intl.formatMessage("agentGroupAddDeletePicker.add");
    case Option.Delete:
      return intl.formatMessage("agentGroupAddDeletePicker.delete");
    default:
      return "";
  }
};

const enum Option {
  Add = "add",
  Delete = "delete"
}
